import { render } from "./courses-list.vue?vue&type=template&id=284c65fe&scoped=true"
import script from "./courses-list.vue?vue&type=script&lang=js"
export * from "./courses-list.vue?vue&type=script&lang=js"

import "./courses-list.vue?vue&type=style&index=0&id=284c65fe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-284c65fe"]])

export default __exports__